import { getServerUri } from "./uriUtility";

/**
 * Fetch export build-plan exclusions for playable-size estimation.
 * Only bases with useExportBuildPlanForSizeEstimate call the server; others skip.
 *
 * @param {string} baseID
 * @param {object} gameConfig effective config (incl. localization overrides)
 * @returns {Promise<object|null>} plan with excludedDestinations, or null
 */
export async function fetchExportSizePlan(baseID, gameConfig) {
  const response = await fetch(getServerUri("version/computeExportSizePlan"), {
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      accessToken: localStorage.getItem("session.accessToken"),
      baseID: String(baseID),
      gameConfig: JSON.stringify(gameConfig)
    })
  });

  if (!response.ok) {
    return null;
  }

  const json = await response.json();
  if (!json.enabled || !json.plan) {
    return null;
  }

  return json.plan;
}

/**
 * Whether a dashboard media slot is excluded from export (stubbed / skip-loaded).
 *
 * @param {object} asset asset record from gameConfig.components.*.selected*
 * @param {object|null} exportSizePlan
 */
export function isAssetExcludedFromExportEstimate(asset, exportSizePlan) {
  if (!exportSizePlan || !Array.isArray(exportSizePlan.excludedDestinations)) {
    return false;
  }

  const destination = asset && asset.destination;
  if (destination == null || destination === "") {
    return false;
  }

  const normalized = String(destination)
    .replace(/^[/\\]+/, "")
    .replace(/^assets\/selected\//, "");

  return exportSizePlan.excludedDestinations.includes(normalized);
}
